import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import AddIcon from '@mui/icons-material/Add';
import SettingsIcon from '@mui/icons-material/Settings';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvVideoPlacementFilterActionsProps {
  canAdd: boolean;
  canManage: boolean;
  onAdd: () => void;
  onManage: () => void;
}

const OvVideoPlacementFilterActions: FC<OvVideoPlacementFilterActionsProps> = ({
  canAdd,
  canManage,
  onAdd,
  onManage,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {canAdd && (
        <Action type="button" onClick={onAdd}>
          <AddIcon aria-hidden="true" />
          {t('videos.placements.add.option')}
        </Action>
      )}
      {canManage && (
        <Action type="button" onClick={onManage}>
          <SettingsIcon aria-hidden="true" />
          {t('videos.placements.manage.open')}
        </Action>
      )}
    </>
  );
};

export default OvVideoPlacementFilterActions;

const Action = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  min-height: 2rem;
  padding: 0.25rem 0.4375rem;
  border: 0;
  border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
  background: transparent;
  color: ${Colours.OV_BASE};
  font: inherit;
  font-size: ${Variables.fontSizes.SMALL};
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: ${Colours.OV_WHITE_HOVER};
  }

  .MuiSvgIcon-root {
    width: 1rem;
    height: 1rem;
  }
`;
